/** URL-safe slug from arbitrary text. */
export function slugify(input: string): string {
  return String(input || '')
    .trim()
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 120);
}

export function deslugify(slug: string): string {
  return slug.replace(/-/g, ' ').trim();
}

/** Build a unique product slug from title; optional suffix when collisions exist. */
export function buildListingSeoSlug(title: string, suffix = ''): string {
  const base = slugify(title) || 'product';
  if (!suffix) return base;
  return `${base}-${suffix}`;
}

export function listingBlob(listing: { title?: string | null; brand?: string | null; description?: string | null; category?: string | null }): string {
  return `${listing.brand || ''} ${listing.title || ''} ${listing.description || ''} ${listing.category || ''}`.toLowerCase();
}

export function listingMatchesTerms(listing: { title?: string | null; brand?: string | null; description?: string | null }, terms: string[]): boolean {
  const blob = listingBlob(listing);
  return terms.every((t) => blob.includes(t.toLowerCase()));
}

export function releaseMonthSlug(year: number, month: number): string {
  const d = new Date(year, month - 1, 1);
  const monthName = d.toLocaleString('en-US', { month: 'long' }).toLowerCase();
  return `${monthName}-${year}`;
}

export function parseReleaseMonthSlug(slug: string): { year: number; month: number } | null {
  const m = slug.match(/^([a-z]+)-(\d{4})$/i);
  if (!m) return null;
  const year = Number(m[2]);
  const monthIdx = new Date(`${m[1]} 1, ${year}`).getMonth();
  if (Number.isNaN(monthIdx) || monthIdx < 0) return null;
  return { year, month: monthIdx + 1 };
}
